import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row, Space, Image, theme, FloatButton } from "antd";
import btnStyles from "../../../styles/Custom/Button.module.css";
import InvestigationModal from "./InvestigationModal";
import { patientInvestigationsViewAPI } from "../../../services/patient.services";
import InvestigationTable from "./InvestigationTable";
import { FileSearchOutlined, UploadOutlined } from "@ant-design/icons";
import InvestigationsUploadModal from "./InvestigationsUploadModal";
import InvestigationGallery from "./InvestigationGallery/InvestigationGallery";
import { useLocation } from "react-router-dom";
import { UserContext } from "../../../context/UserContext";
import NoDataPage from "../../NoDataPages/NoDataPage";
import InvestigationIcon from "../../../assets/images/nurseIcons/investigation.svg";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import { ReactComponent as GalleryIcon } from "../../../assets/doctorIcons/gallery.svg";
import investigationIcon from "../../../assets/doctorIcons/investigation.svg";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
import FloatingRecorder from "../AiAssistant/FloatingRecorder";
import RecordModal from "../AiAssistant/RecordModal";
import aiIcon from "../../../assets/dashboardIcons/aiIcon.svg";
import useIsMobile from "../../../hooks/useIsMobile";
import { UiTablePageToolbar } from "../../ui";
import "./InvestigationsIp.css";
const InvestigationsIP = ({ patientData }) => {
  const { token } = theme.useToken();
  const isMobile = useIsMobile();
  const { userDetails } = useContext(UserContext);
  const location = useLocation();
  const params = Object.fromEntries(new URLSearchParams(location?.search));
  const [open, setOpen] = useState(false);
  const [investigationData, setInvestigationData] = useState(null);
  const [uploadModal, setUploadModal] = useState(false);
  const [galleryModal, setGalleryModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openAiModal, setOpenAiModal] = useState(false);
  const [showFloatingRecorder, setShowFloatingRecorder] = useState(false);
  const [aiResponse, setAiResponse] = useState(null);
  const [nameSearch, setNameSearch] = useState("");
  const isActive = params?.status === "current";
  const userRole = userDetails?.currRole || getCookie(Role);
  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };
  const handleProcessComplete = (responseData) => {
    setAiResponse(responseData);
    setShowFloatingRecorder(false);
    setOpenAiModal(true);
  };
  useEffect(() => {
    patientInvestigationsViewAPI(
      `patient_id=${params?.patient}&ip_admission=${params?.patient}`
    )
      .then((res) => {
        setInvestigationData(res?.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  }, [refresh]);

  const defaultRole = getCookie(Role) || userDetails?.currRole;

  const renderActionButtons = () => (
    <div className="investigations-ip-toolbar">
      <Button
        style={{
          fontWeight: "500",
          height: "40px",
          color: token.colorPrimary,
          borderColor: token.colorPrimary,
        }}
        type="primary"
        ghost
        className={`${btnStyles.mdBtn} inv-btn investigations-ip-action-btn`}
        onClick={() => setGalleryModal(true)}
      >
        <Space>
          <GalleryIcon
            width={20}
            height={20}
            style={{ color: token.colorPrimary }}
          />
        </Space>
        Investigation Gallery
      </Button>
      {isActive && (
        <>
          <Button
            style={{
              fontWeight: "500",
              height: "40px",
              color: token.colorPrimary,
              borderColor: token.colorPrimary,
            }}
            type="link"
            ghost
            className={`${btnStyles.mdBtn} investigations-ip-action-btn`}
            onClick={() => setUploadModal(true)}
          >
            <UploadOutlined /> Initial Investigation
          </Button>
          {!["Nurse", "Receptionist"].includes(defaultRole) && (
            <Button
              type="primary"
              style={{ fontWeight: "500", height: "40px" }}
              className={`${btnStyles.mdBtn} inv-btn investigations-ip-action-btn`}
              onClick={() => setOpen(true)}
            >
              <Space>
                <Image
                  src={investigationIcon}
                  preview={false}
                  width={20}
                  height={20}
                />
              </Space>
              Request Investigation
            </Button>
          )}
        </>
      )}
    </div>
  );

  return (
    <div className="investigations-ip-root">
      {loading ? (
        <LoadingIndicator
          message={"Loading investigation data, please wait..."}
        />
      ) : investigationData && investigationData?.length > 0 ? (
        <Row gutter={[12, 12]}>
          <Col span={24} className="investigations-ip-toolbar-col">
            <UiTablePageToolbar
              className="investigations-ip-header-toolbar"
              searchAlign="start"
              placeholder="Search investigation"
              searchValue={nameSearch}
              onSearch={(e) => setNameSearch(e?.target?.value ?? "")}
              trailing={renderActionButtons()}
            />
          </Col>
          <Col span={24}>
            <InvestigationTable
              data={investigationData}
              refreshPage={refreshPage}
              id={params?.patient}
              patientData={patientData}
              nameSearch={nameSearch}
            />
          </Col>
        </Row>
      ) : (
        <Row
          className="investigations-ip-empty"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: isMobile ? "50vh" : "80vh",
          }}
        >
          <Col span={24} style={{ textAlign: "center" }}>
            <NoDataPage
              title={"No Investigation has been done ! "}
              subtitle={isActive && "Kindly, upload an initial investigation here"}
              image={InvestigationIcon}
            />
            {isActive && (
              <Space
                className="investigations-ip-empty-actions"
                wrap={isMobile}
                direction={isMobile ? "vertical" : "horizontal"}
                style={isMobile ? { width: "100%" } : undefined}
              >
                {defaultRole !== "Nurse" && (
                  <Button
                    style={{ fontWeight: "500", height: "40px" }}
                    type="primary"
                    ghost
                    className={btnStyles.mdBtn}
                    onClick={() => setOpen(true)}
                  >
                    {" "}
                    <Space>
                      <FileSearchOutlined />
                    </Space>
                    Request Investigation
                  </Button>
                )}
                <Button
                  style={{ fontWeight: "500", height: "40px" }}
                  type="primary"
                  className={`${btnStyles.mdBtn} inv-btn`}
                  onClick={() => setUploadModal(true)}
                >
                  <UploadOutlined /> Initial Investigation
                </Button>
              </Space>
            )}
          </Col>
        </Row>
      )}

      {open && (
        <InvestigationModal
          open={open}
          setOpen={setOpen}
          refreshPage={refreshPage}
          id={params?.patient}
        />
      )}
      {uploadModal && (
        <InvestigationsUploadModal
          open={uploadModal}
          setOpen={setUploadModal}
          refreshPage={refreshPage}
          id={params?.patient}
        />
      )}
      {galleryModal && (
        <InvestigationGallery
          open={galleryModal}
          setOpen={setGalleryModal}
          refreshPage={refreshPage}
          id={params?.patient}
          patientData={patientData}
        />
      )}
      {userRole === "Doctor" && (
        <FloatButton
          shape="circle"
          type="primary"
          className="ai-assistant-float"
          icon={<img src={aiIcon} alt="AI Icon" width={25} height={32} />}
          onClick={() => {
            setShowFloatingRecorder(true);
            // setShowTooltip(false);
          }}
        />
      )}
      {showFloatingRecorder && (
        <FloatingRecorder
          onProcessComplete={handleProcessComplete}
          onClose={() => {
            setShowFloatingRecorder(false);
          }}
          userDetails={userDetails}
        />
      )}

      {/* Modal with AI Response */}
      {openAiModal && aiResponse && (
        <RecordModal
          open={openAiModal}
          setOpen={setOpenAiModal}
          refreshPage={refreshPage}
          aiResponse={aiResponse}
          startInFormStep={true}
        />
      )}
    </div>
  );
};

export default InvestigationsIP;
